// extracted by mini-css-extract-plugin
export default {"desc":"desc_QRqXc","nameFront":"nameFront_ZECR_","nameLast":"nameLast_x_Eui","copy":"copy_Ne6tf","finger":"finger_uqmVk","clickbleArea":"clickbleArea_EkJju"};